import React, { useState } from "react";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
  FaBars,
  FaTimes
} from "react-icons/fa";
import "./Navbar.css";
import { Link } from "react-router-dom";
import logo from "../Assessts/newlogo.png";
// import { Italic } from "lucide-react";

export default function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="navbar-container">
      {/* Top Contact Bar */}
      <div className="top-bar">
        <div className="top-left">
          <FaMapMarkerAlt />
          <span>
            11B, 9th Floor, Urbtech NPX, Sector-153, Greater Noida, Delhi-NCR,
            UP, India 201301
          </span>
        </div>
        <div className="top-right">
          <div className="phone">
            <FaPhoneAlt />
          </div>
          <span className="divider">| Contact: +91-9235352625</span>
          <div className="social-icons">
            <a
              href="https://www.facebook.com/profile.php?id=61579445490586"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://x.com/taad_official"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTwitter />
            </a>
            <a
              href="https://www.instagram.com/taad_official/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com/company/technocrat-aerospace-and-defence/about/?viewAsMember=true"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
<div className="main-navbar">
  <Link to="/" className="logo-section"     style={{ textDecoration: "none", color: "#155382ff"}}>
    <div style={{ textAlign: "center" }}>
      <img src={logo} alt="not found" height={40} />
      <p
        style={{
          fontSize: "13px",
          // fontWeight: "bold",
          textDecoration: "none",
          fontStyle: "italic",
          marginTop: "10px",
        }}
      >
        An ISO 9001:2015 & CE certified Company
      </p>
    </div>
  </Link>

        {/* Desktop Links */}
        <div className={`nav-links ${isMobileMenuOpen ? "active" : ""}`}>
          <Link to="/" onClick={() => setIsMobileMenuOpen(false)}>Home</Link>

          <div className="dropdown">
            <Link>About Us</Link>
            <div className="dropdown-content">
              <Link to="/about">About Company</Link>
              <Link to="/founder">Founder & Team</Link>
              <Link to="/certificates">Certifications</Link>
            </div>
          </div>

          <div className="dropdown">
  <Link>Products & Services</Link>
  <div className="dropdown-content">
    {/* First level */}
    <div className="dropdown-submenu">
      <Link>TAAD Products</Link>
      <div className="dropdown-submenu-content">

        <Link to="/OurProducts" onClick={() => setIsMobileMenuOpen(false)}>Aerospace & Defence</Link>
        <Link to="/VisionSystem" onClick={() => setIsMobileMenuOpen(false)}>Rugged Vision Systems</Link>
        <Link to="/DroneSystem" onClick={() => setIsMobileMenuOpen(false)}>Drone and UAV Systems</Link>
        <Link to="/crauzet" onClick={() => setIsMobileMenuOpen(false)}>Railway Products</Link>
        <Link to="/Cybersecurity" onClick={() => setIsMobileMenuOpen(false)}>Cybersecurity</Link>
      </div>
    </div>

    {/* Second main link */}
    <Link to="/ProductsWeDeal" onClick={() => setIsMobileMenuOpen(false)}>Products We Deal</Link>
  </div>
</div>


          <Link to="/Partners" onClick={() => setIsMobileMenuOpen(false)}>Partners</Link>
          <Link to="/Careers" onClick={() => setIsMobileMenuOpen(false)}>Careers</Link>
          <Link to="/Contact" onClick={() => setIsMobileMenuOpen(false)}>Contact</Link>
          <Link to="/request-quote" className="quote-btn" onClick={() => setIsMobileMenuOpen(false)}>
            REQUEST A QUOTE
          </Link>
        </div>

        {/* Hamburger Icon */}
        <div
          className="hamburger"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>
    </div>
  );
}
